export default {"src":"/_next/static/media/production-data.eb392dab.svg","height":512,"width":384,"blurWidth":0,"blurHeight":0};